import { useCallback, useEffect, useState } from "react";
import api, { AI_USAGE_EVENT } from "@/lib/api";

/**
 * AI credit used by the signed-in user (GET /ai/usage). Fetched while `enabled`
 * and refreshed whenever an AI call succeeds (see AI_USAGE_EVENT in lib/api).
 * Returns null until the first successful load.
 */
export default function useAiCredit(enabled = true) {
  const [usage, setUsage] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/ai/usage");
      setUsage(data);
    } catch (err) {
      // Non-fatal — the badge simply stays hidden.
      console.warn("useAiCredit: AI usage load failed:", err?.message || err);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    load();
    window.addEventListener(AI_USAGE_EVENT, load);
    return () => window.removeEventListener(AI_USAGE_EVENT, load);
  }, [enabled, load]);

  return usage;
}
